import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { createDepartmentStart , editDepartmentStart ,deleteDepartmentStart} from "../../redux/departments/reducer";
const useDepartmentEditor = () => {
  const dispatch = useDispatch();

  const createDepartment = useCallback(
    (data) => {
      dispatch(createDepartmentStart(data));
    },
    [dispatch]
  );
  const editDepartment = useCallback(
    (data) => {
      dispatch(editDepartmentStart(data));
    },
    [dispatch]
  );
 
  const deleteDepartment = useCallback(
    (id) => {
      dispatch(deleteDepartmentStart(id));
    },
    [dispatch]
  );
 
  return { createDepartment, editDepartment, deleteDepartment };
};

export default useDepartmentEditor;
